<p-toast position="bottom-right"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>

    <span style="padding-top:2px;">
      <button pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              icon="pi pi-fw pi-refresh" 
              (click)="loadCompanies()"></button>

      <!-- Display only on bigger than md screens-->
      <span class="p-d-none p-d-md-inline">
        <button pButton type="button" 
                class="p-button p-button-text" 
                label="Add Client" 
                icon="pi-fw fas fa-plus-circle"
                (click)="addCompany()"></button>

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="!selectedCompany"
                label="Delete Client" 
                icon="pi-fw fas fa-trash"
                (click)="deleteCompany()"></button>  

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="!selectedCompany"
                label="Add Client Representative" 
                icon="pi-fw fas fa-user-plus"
                (click)="addCompanyRep()"></button>

        <button pButton type="button" 
                class="p-button p-button-text" 
                [disabled]="!selectedRep || !selectedCompany"
                label="Delete Client Representative" 
                icon="pi-fw fas fa-user-minus"
                (click)="deleteCompanyRep()"></button>  
      </span>

      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button pButton type="button" 
                class="p-button-rounded p-button-success"
                icon="pi-fw fas fa-plus-circle"
                (click)="addCompany()"></button>

        <button pButton type="button" 
                class="p-button-rounded p-button-danger"
                [disabled]="!selectedCompany"
                icon="pi-fw fas fa-trash"
                (click)="deleteCompany()"></button>  

        <button pButton type="button" 
                class="p-button-rounded p-button-success"
                [disabled]="!selectedCompany"
                icon="pi-fw fas fa-user-plus"
                (click)="addCompanyRep()"></button>

        <button pButton type="button" 
                class="p-button-rounded p-button-danger"
                [disabled]="!selectedRep || !selectedCompany"
                icon="pi-fw fas fa-user-minus"
                (click)="deleteCompanyRep()"></button>  
      </span>
    </span>
  </div>

  <div class="p-toolbar-group-right">
    <!-- <i class="pi-fw fas fa-user-tag p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
       severity="danger"
       pTooltip="Total Number of Roles: {{roles.length}}"
       value="{{roles.length}}"></i>

    <i class="pi-fw fas fa-users p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
       severity="danger"
       pTooltip="Total Number of Users: {{roleUsers.length}}"
       value="{{roleUsers.length}}"></i>
 -->
  </div>
</p-toolbar>

<p-splitter [style]="{'height': 'calc(100% - 36px)'}" layout="{{smallScreen ? 'vertical' : 'horizontal'}}" [panelSizes]="[40,60]" [gutterSize]="8">
  <ng-template pTemplate>
    <div style="height: 100%; width:100%">
      <ag-grid-angular
          *ngIf="companies.length > 0"
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          rowSelection="single"
          [gridOptions]="companyOptions"
          [context]="companyContext"
          [rowData]="companies"
          [columnDefs]="companyGridHeaders"
          [enterMovesDown]="true"
          [enterMovesDownAfterEdit]="true"
          (gridReady)="onCompanyGridReady($event)"
          (rowClicked)="onCompanyRowClicked($event)"
          (cellKeyDown)="onCompanyCellKeyDown($event)"
          >
      </ag-grid-angular>
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div style="height: 100%; width:100%">
      <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          rowSelection="single"
          [gridOptions]="repOptions"
          [context]="repContext"
          [rowData]="companyReps"
          [columnDefs]="repGridHeaders"
          [enterMovesDown]="true"
          [enterMovesDownAfterEdit]="true"
          (gridReady)="onRepGridReady($event)"
          (rowClicked)="onRepRowClicked($event)"
          (cellKeyDown)="onRepCellKeyDown($event)"
          >
      </ag-grid-angular>
    </div>

  </ng-template>
</p-splitter>


<!-- <ngx-spinner name="companySpinner"
  bdColor="rgba(128, 128, 128, 0.8)"
  size="medium"
  color="#2f9cf2"
  type="ball-clip-rotate"
  [fullScreen]="true">
  <p style="color: white" > Please wait... </p>
</ngx-spinner>

<div *ngIf="isLoggedIn" class="h-100">
  <div class="card">
    <div class="card-header bg-info text-white p-1">
      <a (click)="addCompany()"
        class="btn btn-info btn-sm mr-2">
        <i class="fas fa-plus-circle fa-lg mr-1"></i>Add Client
      </a>
      <a (click)="deleteCompany()"
        [class.disabled]="!selectedCompany"
        class="btn btn-info btn-sm mr-2">
        <i class="fas fa-trash fa-lg mr-1"></i>Delete Client
      </a>

      <a (click)="addCompanyRep()"
        [class.disabled]="!selectedCompany"
        class="btn btn-info btn-sm mr-2">
        <i class="fas fa-user-plus fa-lg mr-1"></i>Add Client Representative
      </a>
      <a (click)="deleteCompanyRep()"
        [class.disabled]="!selectedRep"
        class="btn btn-info btn-sm mr-2">
        <i class="fas fa-user-minus fa-lg mr-1"></i>Delete Client Representative
      </a>
      <a (click)="loadCompanies()"
        class="btn btn-info btn-sm mr-2">
        <i class="fas fa-sync-alt fa-lg mr-1" [class.fa-spin]="entityLoading"></i> Refresh
      </a>
    </div>
    <div class="card-body row m-1 p-0 h-100">
      <div class="col-3 h-100 mr-0 pr-0">
        <ag-grid-angular
          *ngIf="companies.length > 0"
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          rowSelection="single"
          [gridOptions]="companyOptions"
          [context]="companyContext"
          [rowData]="companies"
          [columnDefs]="companyGridHeaders"
          [enterMovesDown]="true"
          [enterMovesDownAfterEdit]="true"
          (gridReady)="onCompanyGridReady($event)"
          (rowClicked)="onCompanyRowClicked($event)"
          (cellKeyDown)="onCompanyCellKeyDown($event)"
          >
        </ag-grid-angular>
      </div>
      <div class="col-4 h-100 ml-1 pl-0">
        <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          rowSelection="single"
          [gridOptions]="repOptions"
          [context]="repContext"
          [rowData]="companyReps"
          [columnDefs]="repGridHeaders"
          [enterMovesDown]="true"
          [enterMovesDownAfterEdit]="true"
          (gridReady)="onRepGridReady($event)"
          (rowClicked)="onRepRowClicked($event)"
          (cellKeyDown)="onRepCellKeyDown($event)"
          >
        </ag-grid-angular>
      </div>
    </div>
  </div>    
</div> 
<zoesen-app-toasts aria-live="polite" aria-atomic="true"></zoesen-app-toasts> -->